import { channel } from "src/service/pusher";

type ClearChannelConversationsUnbindProps = {
    conversation?: string;
};

export const clearChannelConversationsUnbind = ({
    conversation,
}: ClearChannelConversationsUnbindProps) => {
    if (conversation) {
        channel.unbind(`status_change_conversation_${conversation}`);
    }
};